"use client";

import { useState } from "react";
import { useSelector } from "react-redux";
import { Dialog, Modal } from "staysure-component-library";

import StAmtTogleModal from "@/components/molecules/quote-section/quote-cover/st-amt-togle-modal/st-amt-togle-modal";
import SingleTripAMTToggleBottom from "@/components/molecules/quote-section/single-trip-amt-toggle-bottom/single-trip-amt-toggle-bottom";
import TripDurationInformation from "@/components/molecules/quote-section/trip-duration-information/trip-duration-information";
import { useQuoteDisabled } from "@/hooks/use-quote-disabled/use-quote-disabled";
import { useLoading } from "@/providers/loading-provider";
import {
  QuoteBottomToggleContentType,
  ToggleModalContentType,
} from "@/schema/quote-page/page.schema";
import { RootState } from "@/store/root-reducer";

export default function AtmToggleBottom({
  tripDetailsBottomAreaContent,
  toggleModalContent,
}: Readonly<{
  tripDetailsBottomAreaContent: QuoteBottomToggleContentType | null;
  toggleModalContent: ToggleModalContentType | null;
}>) {
  const { attributes } = useSelector((state: RootState) => state.quote);
  const isQuoteDisabled = useQuoteDisabled();
  const { isLoading } = useLoading();
  const tripDetails = attributes?.tripDetails;

  const [isAmtModalOpen, setIsAmtModalOpen] = useState(false);

  if (!tripDetailsBottomAreaContent) {
    return null;
  }

  if (!toggleModalContent) {
    return null;
  }

  const {
    stAmtToggleNewDateDatePickerPlaceHolder = "",
    stAmtToggleNewDateTitle = "",
    stAmtToggleCancellaionContinueBtnLabele = "",
    stAmtToggleCancellaionDescription = "",
    stAmtToggleCancellaionDescriptionMoreThanNinetyDays = "",
    stAmtToggleCancellaionNewDateBtnLabel = "",
    stAmtToggleCancellaionTitle = "",
    stAmtToggleNewDateCancelButtonLabel = "",
    stAmtToggleNewDateUpdateBtnLabel = "",
  } = toggleModalContent;

  const {
    singleTripLeftTitle = "",
    singleTripRightTitle = "",
    singleTripRightDescription = "",
    singleTripRightCtaLabel = "",
    multiTripTitle = "",
    multiTripDescription = "",
  } = tripDetailsBottomAreaContent;

  return (
    <div
      data-testid="atm-toggle-bottom-wrapper-test-id"
      className="flex justify-center items-center w-auto h-auto px-spacing-l md:px-0"
      // ref={acoRef}
    >
      {isAmtModalOpen && (
        <Modal
          onOpenChange={(e: boolean) => setIsAmtModalOpen(e)}
          isOpen={isAmtModalOpen}
          modalStyles={{
            top: `50%`,
            left: `50%`,
            transform: `translate(-50%, -50%)`,
          }}
          className={`bg-surface-neutral-option-1 md:max-w-[416px] max-w-[312px] relative rounded-radius-lg `}
          uderlayClassName={`${
            isLoading ? "z-[-1]" : "z-[100]"
          } bg-interactive-overlay-default`}
        >
          <Dialog className=" relative">
            <StAmtTogleModal
              onCancel={() => {
                setIsAmtModalOpen(false);
              }}
              stAmtToggleCancellaionTitle={stAmtToggleCancellaionTitle}
              stAmtToggleCancellaionDescription={
                stAmtToggleCancellaionDescription
              }
              stAmtToggleCancellaionDescriptionMoreThanNinetyDays={
                stAmtToggleCancellaionDescriptionMoreThanNinetyDays
              }
              stAmtToggleCancellaionContinueBtnLabele={
                stAmtToggleCancellaionContinueBtnLabele
              }
              stAmtToggleCancellaionNewDateBtnLabel={
                stAmtToggleCancellaionNewDateBtnLabel
              }
              stAmtToggleNewDateDatePickerPlaceHolder={
                stAmtToggleNewDateDatePickerPlaceHolder
              }
              stAmtToggleNewDateTitle={stAmtToggleNewDateTitle}
              stAmtToggleNewDateUpdateBtnLabel={
                stAmtToggleNewDateUpdateBtnLabel
              }
              stAmtToggleNewDateCancelButtonLabel={
                stAmtToggleNewDateCancelButtonLabel
              }
              isOpenViaBottomToggle
            />
          </Dialog>
        </Modal>
      )}
      {tripDetails?.policyType === "SINGLE_TRIP" ? (
        <SingleTripAMTToggleBottom
          singleTripLeftTitle={singleTripLeftTitle}
          singleTripRightTitle={singleTripRightTitle}
          singleTripRightDescription={singleTripRightDescription}
          singleTripRightCtaLabel={singleTripRightCtaLabel}
          onClick={() => {
            setIsAmtModalOpen(true);
          }}
          isDisabled={isQuoteDisabled}
        />
      ) : (
        <TripDurationInformation
          multiTripTitle={multiTripTitle}
          multiTripDescription={multiTripDescription}
        />
      )}
    </div>
  );
}
